import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import {
  GetSimDocsResponseBody,
  SubmitDocumentResponseBody,
  VerifySignatureResponseBody,
} from 'api/types/doc'

class Doc {
  // get all brokers a user belongs to
  async getDocumentList(
    policyNo: number,
    eventNo: number,
    docType?: string,
    invoiceNo?: string,
  ): Promise<any | AxiosError | Error> {
    if (docType) {
      let url = `${APIRoutes.doc.getDocumentList}?policyNo=${policyNo}&eventNo=${eventNo}`

      if (docType) {
        url += `&docType=${docType}`
      }

      if (invoiceNo) {
        url += `&invoiceNo=${invoiceNo}`
      }

      return ApiProvider.getRequest(url) as Promise<any | AxiosError | Error>
    } else {
      const url = `${APIRoutes.doc.getDocumentList}?policyNo=${policyNo}&eventNo=${eventNo}`

      return ApiProvider.getRequest(url) as Promise<any | AxiosError | Error>
    }
  }

  // get simulation documents
  async getSimDocs(
    policyNo: number,
    eventNo: number,
  ): Promise<GetSimDocsResponseBody | AxiosError | Error> {
    const url = `${APIRoutes.doc.getSimDocs}?policyNo=${policyNo}&eventNo=${eventNo}`

    return ApiProvider.getRequest(url) as Promise<
      GetSimDocsResponseBody | AxiosError | Error
    >
  }

  // submit document
  async submitDocument({
    policyNo,
    base64String,
  }: {
    policyNo: number
    base64String: string
  }): Promise<SubmitDocumentResponseBody | AxiosError | Error> {
    const url = `${APIRoutes.doc.submitDocument}?policyNo=${policyNo}&digitalSign=0`

    return ApiProvider.postRequest(url, {
      name: `proposta-${policyNo}`,
      filename: `proposta-${policyNo}.pdf`,
      document: base64String,
    }) as Promise<SubmitDocumentResponseBody | AxiosError | Error>
  }

  // verify signature
  async verifySignature({
    policyNo,
    base64String,
  }: {
    policyNo: number
    base64String: string
  }): Promise<VerifySignatureResponseBody | AxiosError | Error> {
    const url = APIRoutes.doc.verifySignature

    return ApiProvider.postRequest(url, {
      id: 0,
      name: `proposta-${policyNo}`,
      bytes: base64String,
    }) as Promise<VerifySignatureResponseBody | AxiosError | Error>
  }
}

export const docService = new Doc()
